export const initialState = {
     products : [],
     user : null,
     userIdhasAccess : ["100396685240574444002" , "103114323682823297903", "108178530753483406090","111857150850047118482"],
     isAuthorized : false
}